module.exports = __webpack_public_path__ + "static/media/A5v6.513b03da.mp3";